import React, { useMemo } from 'react';
import { RouteComponentProps, useHistory, useLocation, Redirect } from 'react-router-dom';
import { Tabs } from 'antd';
import { useGetMyAccountQuery } from 'graphql/types';
import { StyledLayout, StyledTabsWrap, StyledWrapper } from './index.styled';
import AccountRouter from './router';

export default function Account({ match }: RouteComponentProps) {
  const history = useHistory();
  const location = useLocation();

  const clickHandler = (path: string) => {
    history.push(`${match.url}${path}`);
  };

  const { data: accountResult } = useGetMyAccountQuery();
  const accountTreeId = useMemo(() => {
    return accountResult?.myAccount?.data?.attributes?.myTreeId || null;
  }, [accountResult]);

  if (accountTreeId === null) {
    return null;
  }

  const familyTreePath = `/family-tree/${accountTreeId}`;

  if (location.pathname === match.url || location.pathname === `${match.url}/`) {
    return <Redirect to={`${match.url}${familyTreePath}`} />;
  }

  const navItems = [
    { text: 'Family Tree', path: familyTreePath },
    { text: 'Settings', path: '/profile' },
  ];
  const activePath = navItems.find((item) => location.pathname.includes(item.path))?.path || familyTreePath;

  return (
    <StyledWrapper>
      <StyledLayout>
        <StyledTabsWrap>
          <Tabs
            activeKey={activePath}
            onChange={clickHandler}
            items={navItems.map((item) => ({ key: item.path, label: item.text.toUpperCase() }))}
          />
        </StyledTabsWrap>
        <AccountRouter url={match.url} />
      </StyledLayout>
    </StyledWrapper>
  );
}
